<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="py-12">
    <div class="container-wrap">
      <div class="desktop:flex">
        <div class="mb-4 w-full desktop:mb-0 desktop:w-4/12 desktop:pr-8">
          <h2 class="text-h2 mb-6">
            {{ productName }}
            <br />
            {{ t('title') }}
          </h2>
        </div>
        <div class="w-full desktop:w-8/12 desktop:pl-8">
          <div
            class="markdown-content"
            v-html="provideMarkdownHtml(pricingOverview)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });

  const pricingStore = usePricingStore();
  const { productName, pricingOverview } = storeToRefs(pricingStore);
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Pricing Overview"
  },
  "en-jp": {
    "title": "Pricing Overview"
  },
  "en-tw": {
    "title": "Pricing Overview"
  },
  "en-kr": {
    "title": "Pricing Overview"
  },
  "en-americas": {
    "title": "Pricing Overview"
  },
  "en-asia-pacific": {
    "title": "Pricing Overview"
  },
  "en-emea": {
    "title": "Pricing Overview"
  },
  "ja-jp": {
    "title": "価格概要"
  },
  "zh-cn": {
    "title": "价格概览"
  },
  "zh-tw": {
    "title": "價格概覽"
  }
}
</i18n>
